import PropTypes from 'prop-types'
import UserAvatar from 'react-user-avatar'

const AvatarAlias = ({ name, size, className }) => {
  const cleanName = name.replace(/[^a-zA-Z\s.]+/g, '').trim()
  const names = cleanName.match(/\b(\w+)\b/g) || []
  const abrNames = [names[0], names[2] || names[1]].filter(Boolean).join(' ') || ' '

  return <UserAvatar name={abrNames} size={size} className={`text-white ${className}`} />
}

AvatarAlias.propTypes = {
  name: PropTypes.string.isRequired,
  size: PropTypes.number,
  className: PropTypes.string,
}

AvatarAlias.defaultProps = {
  size: 40,
  className: '',
}

export default AvatarAlias
